import { intent_labels } from '@akin-home/chat';

export { intent_labels };
